module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "fcc-logo.4661ac00.png";